import React from "react";
import { TabPane as BaseTabPane } from "reactstrap";
import { Route } from "react-router-dom";

const TabPane = ({
  component: Component,
  path,
  exact,
  strict,
  sensitive,
  render,
  ...props
}) => (
  <BaseTabPane className="pt-3">
    <Route
      path={path}
      exact={exact}
      strict={strict}
      sensitive={sensitive}
      render={render || (() => <Component {...props} />)}
    />
  </BaseTabPane>
);

export default TabPane;
